<div class="landing-container d-flex flex-column">
    <audio autoplay="true" autoplay loop src="assets/audio/marcha.mp3" controlsList="nodownload"></audio>
    <div class="moneda-cover">
        <img waitableImage [style.display]="!transitionStarted  ?'flex': 'none'" [@fadeInOut]="imagesState"
            alt="La Moneda de noche" class="moneda-image" src="assets/illustrations/moneda-noche.png">
        <img waitableImage [style.display]="transitionStarted  ?'flex': 'none'" #monedaCoverImage alt="La Moneda de día"
            class="moneda-image" src="assets/illustrations/moneda_dia.png">
        <ng-container *ngIf="monedaCoverImagePositionAndSize != null && scrWidth != null">
            <img waitableImage [@slideInFromRight]="{value: imagesState, params: { delay: 1000, duration: 1000 }}"
                [style.position]="'absolute'" [style.height]="(monedaCoverImagePositionAndSize.height * 0.6) + 'px'"
                [style.top]="'calc(' + (monedaCoverImagePositionAndSize.offsetBottom - (monedaCoverImagePositionAndSize.height * 0.8)) + 'px - 2%)'"
                [style.right]="'28%'" alt="Estudiantes del pasado" src="assets/illustrations/estudiante-pasado-1.png">
            <img waitableImage [@slideInFromRight]="{value: imagesState, params: { delay: 1000, duration: 1000 }}"
                [style.position]="'absolute'" [style.height]="(monedaCoverImagePositionAndSize.height * 0.6) + 'px'"
                [style.top]="'calc(' + (monedaCoverImagePositionAndSize.offsetBottom - (monedaCoverImagePositionAndSize.height * 0.8)) + 'px - 2%)'"
                [style.right]="'22%'" alt="Estudiantes del pasado" src="assets/illustrations/estudiante-pasado-2.png">
            <img waitableImage [@slideInFromRight]="{value: imagesState, params: { duration: 1200, delay: 1000 }}"
                [style.position]="'absolute'" [style.height]="(monedaCoverImagePositionAndSize.height * 0.55) + 'px'"
                [style.top]="'calc(' + (monedaCoverImagePositionAndSize.offsetBottom - (monedaCoverImagePositionAndSize.height * 0.75)) + 'px - 2%)'"
                [style.right]="'14%'" alt="Estudiantes del presente"
                src="assets/illustrations/estudiantes_presente_1.png">
            <img waitableImage [@slideInFromRight]="{value: imagesState, params: { duration: 1500, delay: 1000 }}"
                [style.position]="'absolute'" [style.height]="(monedaCoverImagePositionAndSize.height * 0.6) + 'px'"
                [style.top]="'calc(' + (monedaCoverImagePositionAndSize.offsetBottom - (monedaCoverImagePositionAndSize.height * 0.8)) + 'px - 2%)'"
                [style.right]="'5%'" alt="Estudiantes del presente"
                src="assets/illustrations/estudiantes_presente_2.png">
            <img waitableImage [@slideInFromLeft]="{value: imagesState, params: { duration: 2000, delay: 1600 }}"
                [style.position]="'absolute'" [style.height]="(monedaCoverImagePositionAndSize.height * 0.65) + 'px'"
                [style.top]="'calc(' + (monedaCoverImagePositionAndSize.offsetBottom - (monedaCoverImagePositionAndSize.height * 0.85)) + 'px - 2%)'"
                [style.left]="'0%'" alt="Micro" src="assets/illustrations/micro.png">

        </ng-container>

    </div>

    <footer class="flowers-footer d-none d-md-flex justify-content-between">

        <div class="image-container">
            <img waitableImage src="assets/illustrations/landing/flores/1.png">
        </div>
        <div class="image-container">
            <img class="logo" alt="Logo Programa MMDDHH/UAH" src="assets/logos/logo-programa-mmddhh.png">

        </div>
        <div class="image-container">
            <img class="logo logo-mmddhh" alt="Logo MMDDHH" src="assets/logos/mmddhh.png">

        </div>
        <div class="image-container">
            <img class="logo logo-uah" alt="Logo UAH" src="assets/logos/uah.png">

        </div>
        <div class="image-container">
            <img waitableImage src="assets/illustrations/landing/flores/2.png">

        </div>
        <div class="image-container">
            <img class="logo" alt="Logo UACh" src="assets/logos/logo-uach.png">

        </div>
        <div class="image-container">
            <img waitableImage src="assets/illustrations/landing/flores/3.png">

        </div>
        <div class="image-container">
            <img waitableImage src="assets/illustrations/landing/flores/4.png">

        </div>
        <div class="image-container">
            <img waitableImage src="assets/illustrations/landing/flores/5.png">

        </div>
        <div class="image-container">
            <img waitableImage src="assets/illustrations/landing/flores/6.png">

        </div>

        <div class="image-container web-reference d-flex flex-row align-items-end">
            <a target="_blank" href="https://www.memoriayderechoshumanosuah.org" class="link-unstyled"><img class="icon"
                    alt="Web MMDDHH" src="assets/icons/web.png"></a>
        </div>

        <div class=" image-container  web-reference d-flex flex-row align-items-end">

            <a target="_blank" href="https://www.instagram.com/memoriayderechoshumanos_uah/" class="link-unstyled"><img
                    class="icon" alt="Instagram" src="assets/icons/instagram.png"></a>

        </div>

        <div class="image-container web-reference d-flex flex-row align-items-end">

            <a target="_blank" href="https://www.youtube.com/channel/UCmEgeiMNFDeJ9JVm2Sz8jWw"
                class="link-unstyled"><img class="icon" alt="Youtube" src="assets/icons/youtube.png"></a>

        </div>

        <div class="image-container web-reference d-flex flex-row align-items-end">

            <a target="_blank" href="https://facebook.com/tecnopoluah" class="link-unstyled"><img class="icon"
                    alt="Facebook" src="assets/icons/facebook.png"></a>
        </div>
        <div class="image-container">
            <img waitableImage src="assets/illustrations/landing/flores/7.png">
        </div>

    </footer>

    <footer class="flowers-footer mobile d-flex flex-column d-md-none justify-content-between">
        <div class="logos d-flex flex-nowrap justify-content-center">
            <div class="image-container">
                <img class="logo" alt="Logo Programa MMDDHH/UAH" src="assets/logos/logo-programa-mmddhh.png">

            </div>
            <div class="image-container">
                <img class="logo logo-mmddhh" alt="Logo MMDDHH" src="assets/logos/mmddhh.png">

            </div>
            <div class="image-container">
                <img class="logo logo-uah" alt="Logo UAH" src="assets/logos/uah.png">

            </div>

            <div class="image-container">
                <img class="logo" alt="Logo UACh" src="assets/logos/logo-uach.png">

            </div>

        </div>
        <div class="d-flex flex-nowrap justify-content-center">
            <div class="image-container web-reference d-flex flex-row align-items-end">
                <a target="_blank" href="https://www.memoriayderechoshumanosuah.org" class="link-unstyled"><img
                        class="icon" alt="Web MMDDHH" src="assets/icons/web.png"></a>
            </div>

            <div class=" image-container  web-reference d-flex flex-row align-items-end">

                <a target="_blank" href="https://www.instagram.com/memoriayderechoshumanos_uah/"
                    class="link-unstyled"><img class="icon" alt="Instagram" src="assets/icons/instagram.png"></a>

            </div>

            <div class="image-container web-reference d-flex flex-row align-items-end">

                <a target="_blank" href="https://www.youtube.com/channel/UCmEgeiMNFDeJ9JVm2Sz8jWw"
                    class="link-unstyled"><img class="icon" alt="Youtube" src="assets/icons/youtube.png"></a>

            </div>

            <div class="image-container web-reference d-flex flex-row align-items-end">

                <a target="_blank" href="https://facebook.com/tecnopoluah" class="link-unstyled"><img class="icon"
                        alt="Facebook" src="assets/icons/facebook.png"></a>
            </div>
        </div>
        <div class="flowers d-flex flex-nowrap">

            <div class="image-container">
                <img waitableImage src="assets/illustrations/landing/flores/1.png">
            </div>


            <div class="image-container">
                <img waitableImage src="assets/illustrations/landing/flores/2.png">

            </div>

            <div class="image-container">
                <img waitableImage src="assets/illustrations/landing/flores/3.png">

            </div>
            <div class="image-container">
                <img waitableImage src="assets/illustrations/landing/flores/4.png">

            </div>
            <div class="image-container">
                <img waitableImage src="assets/illustrations/landing/flores/5.png">

            </div>
            <div class="image-container">
                <img waitableImage src="assets/illustrations/landing/flores/6.png">

            </div>
            <div class="image-container">
                <img waitableImage src="assets/illustrations/landing/flores/7.png">
            </div>
        </div>



    </footer>
</div>